export default __webpack_public_path__ + "static/media/AxionAccelerator_Supernova.0fb152c1.svg";